import {inject, observer} from 'mobx-react';
import React, {useEffect, useState} from 'react';
import CreateMicrolessonUI from '../view/CreateMicrolessonUI';
import CreateMicrolessonStore from '../store/CreateMicrolessonStore';
import {
  CreateMicrolessonModel,
  Microlesson,
} from '../../../data/models/Microlessons/Microlesson';
import {useNavigate, useParams} from 'react-router-dom';

interface Props {
  createMicrolessonStore?: CreateMicrolessonStore;
}

const CreateMicrolessonContainer = inject('createMicrolessonStore')(
  observer(({createMicrolessonStore}: Props) => {
    const [microlesson, setMicrolesson] = useState<Microlesson>();
    const {organizationId} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
      if (!createMicrolessonStore!.isShown) {
        setMicrolesson(undefined);
        return;
      }

      if (organizationId) {
        createMicrolessonStore!
          .getMicrolesson(organizationId)
          .then(setMicrolesson);
      }
    }, [createMicrolessonStore!.isShown]);

    const onCancel = () => {
      createMicrolessonStore!.hideWizard();
    };

    const onCreate = async (
      model: CreateMicrolessonModel,
      avatar?: File,
      navigateNext?: boolean,
    ) => {
      if (organizationId) {
        if (microlesson) {
          const success = await createMicrolessonStore!.editMicrolesson(
            organizationId,
            microlesson.id,
            model,
            avatar,
          );
          if (success && navigateNext) {
            navigate(
              `/editor/${organizationId}/microlessons/${microlesson.id}`,
            );
            createMicrolessonStore!.hideWizard();
          } else if (success) {
            createMicrolessonStore!.hideWizard();
          }
        } else {
          const result = await createMicrolessonStore!.createMicrolesson(
            organizationId,
            model,
            avatar,
          );
          if (result.data && navigateNext) {
            navigate(
              `/editor/${organizationId}/microlessons/${result.data.id}`,
            );
            createMicrolessonStore!.hideWizard();
          } else if (result.data) {
            createMicrolessonStore!.hideWizard();
          }
        }
      }
    };

    return createMicrolessonStore!.isShown ? (
      <CreateMicrolessonUI
        onCancel={onCancel}
        onCreate={onCreate}
        isLoading={createMicrolessonStore!.isLoading}
        microlesson={microlesson}
      />
    ) : null;
  }),
);

export default CreateMicrolessonContainer;
